/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InformationAliases {
  AUTOCOMPLETE_ADDRESS_CATALOG = 'autocomplete-address-catalog',
  AUTOCOMPLETE_CITY_BOLIVIA = 'autocomplete-city-bolivia',
  AUTOCOMPLETE_STATE = 'autocomplete-state',
  AUTOCOMPLETE_STATE_BOLIVIA = 'autocomplete-state-bolivia',
  AUTOCOMPLETE_STATE_PROVINCE_BOLIVIA = 'autocomplete-state-province-bolivia',
  FETCH_ADDRESS_CATALOG = 'fetch-address-catalog',
  FETCH_CITY_BOLIVIA = 'fetch-city-bolivia',
  FETCH_DEMOGRAPGIC = 'fetch-demograpgic',
  FETCH_STATE = 'fetch-state',
  FETCH_STATE_BOLIVIA = 'fetch-state-bolivia',
  FETCH_STATE_PROVINCE_BOLIVIA = 'fetch-state-province-bolivia',
  FIELD_ADDRESS = 'field-address ',
  FIELD_ADDRESS_CATALOG = 'field-address-catalog',
  FIELD_CITY_BOLIVIA = 'field-city-bolivia',
  FIELD_CITY_DISPLAY = 'field-city-display',
  FIELD_COMPLEMENT_BOLIVIA = 'field-complement-bolivia',
  FIELD_LOCALIDADE_BOLIVIA = 'field-localidade-bolivia',
  FIELD_NEIGHBORHOOD = 'field-neighborhood',
  FIELD_NEIGHBORHOOD_BOLIVIA = 'field-neighborhood-bolivia',
  FIELD_NR_TELEFONE = 'field-nrTelefone',
  FIELD_NUMBER = 'field-number',
  FIELD_POST_CODE = 'field-post-code',
  FIELD_STATE = 'field-state',
  FIELD_STATE_BOLIVIA = 'field-state-bolivia',
  FIELD_STATE_PROVINCE_BOLIVIA = 'field-state-province-bolivia',
  FIELD_STREET_BOLIVIA = 'field-street-bolivia',
  FORM_DEMOGRAPHIC = 'form-demographic',
  INPUT_CITY = 'input-city',
  INPUT_COMPLEMENT_BOLIVIA = 'input-complement-bolivia',
  INPUT_DEMOGRAPHIC_FORMULARY_ADDRESS_INFORMATION = 'input-demographic-formulary-address-information',
  INPUT_DEMOGRAPHIC_FORMULARY_NEIGHBORHOOD_INFORMATION = 'input-demographic-formulary-neighborhood-information',
  INPUT_DEMOGRAPHIC_FORMULARY_NUMBER_INFORMATION = 'input-demographic-formulary-number-information',
  INPUT_LOCALIDADE_BOLIVIA = 'input-localidade-bolivia',
  INPUT_NEIGHBORHOOD_BOLIVIA = 'input-neighborhood-bolivia',
  INPUT_POSTAL_CODE = 'input-postal-code',
  INPUT_STREET_BOLIVIA = 'input-street-bolivia',
  LAYOUT_DEMOGRAPHIC_FORMULARY_INFORMATION = 'layout-demographic-formulary-information',
  LAYOUT_DEMOGRAPHIC_INFO = 'layout-demographic-info',
  LAYOUT_DEMOGRAPHIC_INFORMATION_INFORMATION = 'layout-demographic-information-information',
  MAPPER_ADDRESS_CATALOG = 'mapper-address-catalog',
  MAPPER_CITY_BOLIVIA = 'mapper-city-bolivia',
  MAPPER_STATE = 'mapper-state',
  MAPPER_STATE_BOLIVIA = 'mapper-state-bolivia',
  MAPPER_STATE_PROVINCE_BOLIVIA = 'mapper-state-province-bolivia',
  MAPPER_TELEFONE = 'mapper-telefone',
  PANEL_DEMOGRAPHIC = 'panel-demographic',
  PANEL_DEMOGRAPHIC_INFORMATION_INFORMATION = 'panel-demographic-information-information',
  PANEL_TELEFONE = 'panel-telefone',
  PHONE_NUMBER_NR_TELEFONE = 'phone-number-nrTelefone',
  TEXT_ADDRESS_CATALOG = 'text-address-catalog',
  TEXT_CITY_BOLIVIA = 'text-city-bolivia',
  TEXT_STATE = 'text-state',
  TEXT_STATE_BOLIVIA = 'text-state-bolivia',
  TEXT_STATE_PROVINCE_BOLIVIA = 'text-state-province-bolivia',
}
export { InformationAliases };
